import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import DashboardLoader from '../../CommonComponents/dashboard-docchat/DashboardLoader';
import Loader from '../../CommonComponents/Loader';
import Navbar from '../../CommonComponents/Navbar/Navbar';
import { SavedComparisonsDocChat } from '../../CommonComponents/SavedComparisons';
import WelcomeModal from '../../CommonComponents/WelcomeModal';
import { useOneTimeModal } from '../../CommonFuctions/useOneTimeModal';
import {
  DOC_CHAT,
  DOCCHAT_MAX_FILES,
  LOADING,
  WELCOME_MODAL_DOC_CHAT,
} from '../../Constants/commonConstants';
import { uploadDocument } from '../../Redux/DocChat/docChatActions';
import { useBackToID } from '../../utils/hooks/useBackToID';
import FilePickerDocChat from '../FilePicker/FilePickerDocChat';

let timerId = null;

const getLastUntitledFolderIndex = (data) => {
  // Regex to match "Untitled Folder - <number>"
  const regex = /^Untitled Folder - (\d+)$/;

  // Extract indices from collection_name matching the pattern
  const indices = data
    ?.map((item) => {
      const match = regex.exec(item.collection_name?.trim()); // Ensure no extra spaces
      return match ? parseInt(match[1], 10) : null;
    })
    .filter((index) => index !== null); // Remove null values

  // Return the highest index or 0 if no matches are found
  return indices?.length > 0 ? Math.max(...indices) : 0;
};

const DashboardDocChat = () => {
  const dispatch = useDispatch();
  const { uploadStatus, records } = useSelector((state) => state.docChatData);
  const [uploadData, setUploadData] = useState({ file: '' });
  const [isLoaderOpen, setIsLoaderOpen] = useState(true);
  const [addFileData, setAddFileData] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const { userData, docChatQuota } = useSelector((state) => state.loginState);

  const { clearBackPath } = useBackToID(DOC_CHAT);

  const { modalOpen: docChatWelcomeModalOpen, closeModal: closeDocChatWelcomeModal } =
    useOneTimeModal(WELCOME_MODAL_DOC_CHAT, { delay: 2000 });

  useEffect(() => {
    localStorage.setItem('product', 'docchat');
    clearBackPath();
    if (userData?.name) {
      setIsLoaderOpen(false);
    } else {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        setIsLoaderOpen(false);
      }, 1000);
    }
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  useEffect(() => {
    const { file, collection_id, noLeft } = location.state || {
      file: null,
      collection_id: null,
      noLeft: null,
      ...location?.state,
    };
    if (file && file !== '') {
      if (noLeft) {
        setAddFileData({ file, collection_id, noLeft });
      }
      sendData({ file, collection_id, noLeft });

      // Clear location.state
      navigate(location.pathname, { replace: true });
    } else {
      console.error('No file found in state');
    }
  }, [location.state]);

  const sendData = ({
    file,
    collection_id,
    collectionName,
    noLeft,
    uploadType,
    query,
    presetId,
  }) => {
    const fileArr = Array.from(file);
    const noFiles = fileArr.length;

    // Handle file upload with valid files only
    if (noFiles > 0 && (noLeft ? noLeft >= noFiles : noFiles <= DOCCHAT_MAX_FILES)) {
      const formData = new FormData();
      if (collection_id) {
        formData.append('collection_id', collection_id);
      }
      if (noFiles > 1 || collection_id) {
        if (!collection_id) {
          const lastIndex = getLastUntitledFolderIndex(records);
          if (uploadType !== 'individual') {
            formData.append(
              'collection_name',
              collectionName || `Untitled Folder - ${lastIndex + 1}`
            );
          }
        }
        formData.append('upload_type', uploadType || 'collection');
        fileArr.forEach((fileItem) => {
          formData.append('files', fileItem);
        });
      } else {
        formData.append('files', fileArr[0]);
      }
      formData.append('userID', userData?.id);
      if (query) {
        formData.append('query', query);
      }
      if (presetId) {
        formData.append('preset_id', presetId);
      }
      dispatch(
        uploadDocument({
          formData,
          noFiles,
          collection_id,
          presetId,
        })
      );
    }
  };

  return (
    <div className='docchat-dashboard-container'>
      <WelcomeModal
        open={docChatWelcomeModalOpen}
        variant='DocChat'
        onCtaClick={closeDocChatWelcomeModal}
      />
      <Navbar product={DOC_CHAT} />
      {isLoaderOpen && <Loader time='100' product={DOC_CHAT} />}
      <section className='docchat-dashboard-container-inner'>
        <SavedComparisonsDocChat
          uploadStatus={uploadStatus}
          userData={userData}
          docChatQuota={docChatQuota}
          screen='docchat-dashboard'
        />
        {uploadStatus === LOADING ? (
          <DashboardLoader product='docchat' />
        ) : (
          <FilePickerDocChat
            uploadData={uploadData}
            setUploadData={setUploadData}
            sendData={sendData}
            addFileData={addFileData}
            docChatQuota={docChatQuota}
          />
        )}
      </section>
    </div>
  );
};

export default DashboardDocChat;
